import { Component, EventEmitter, Input, Output } from '@angular/core';

import { InvoicePosition } from '@jessie/commons';
import { FormatPercent } from '../../../../../pipes/format-percent';
import { StringToNumber } from '../../../../../pipes/string-to-number';
import { FormatAmount } from '../../../../../pipes/format-amount';
import { NgIconWrapperComponent } from '../../../../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';

const UNIT_TEXTS: Record<InvoicePosition['unit'], string> = {
  hours: 'Stunden',
  piece: 'Stück',
  fixedPrice: 'Fixpreis',
  none: '',
};

@Component({
  selector: 'tr[app-free-position-row]',
  imports: [FormatAmount, FormatPercent, StringToNumber, NgIconWrapperComponent],
  templateUrl: './free-position-row.component.html',
})
export class FreePositionRowComponent {
  @Input() position!: InvoicePosition;
  @Input() isDisabled = false;
  @Output() editPosition = new EventEmitter<InvoicePosition>();
  @Output() deletePosition = new EventEmitter<InvoicePosition>();

  get unitText(): string {
    return UNIT_TEXTS[this.position.unit];
  }
}
